export function copyDeep(object) {
  return JSON.parse(JSON.stringify(object))
}
